import { render, staticRenderFns } from "./CommonProgress.vue?vue&type=template&id=45774679&"
import script from "./CommonProgress.vue?vue&type=script&lang=js&"
export * from "./CommonProgress.vue?vue&type=script&lang=js&"
import style0 from "./CommonProgress.vue?vue&type=style&index=0&id=45774679&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports